$(document).on("turbolinks:load", function () {
  const filters = $(".page-filter").find($("*[data-page-filter]"));
  const filtersClear = $('*[data-action="filters-clear"]');

  filters.each(function (index, filter) {
    handleFilter(filter);
  });

  $(filtersClear).on("click", (e) => {
    const filterKeys = ["destination", "type"];
    const urlParams = new URLSearchParams(window.location.search);

    filterKeys.forEach((filterKey) => {
      urlParams.delete(filterKey);
    });

    if ([...urlParams.keys()].length > 0) {
      window.location.search = urlParams;
    } else {
      window.location = window.location.href.split("?")[0];
    }

    return false;
  });

  $(document).on("onFilterApplied", () => {
    const filterData = {};
    const filters = document.querySelectorAll("[data-page-filter]");

    filters.forEach((filter) => {
      const selectedItems = [];
      const filterKey = filter.getAttribute("data-page-filter");
      const suggestions = $(filter).find('*[data-ui="suggestions"]');
      const sorter = $(filter).find('*[data-ui="sorter"]');
      const suggestionItems = $(suggestions).children("*[data-value]");
      const sorterItems = $(sorter).children("*[data-value]");

      $(filterKey === "orderby" ? sorterItems : suggestionItems).each(
        (index, suggestionItem) => {
          if ($(suggestionItem).hasClass("active")) {
            selectedItems.push($(suggestionItem).attr("data-value"));
          }
        }
      );

      filterData[filterKey] = selectedItems.join(",");

      const urlParams = new URLSearchParams(window.location.search);

      for (const [key, value] of Object.entries(filterData)) {
        if (!value) {
          urlParams.delete(key);
        } else {
          urlParams.set(key, value);
        }
      }

      if ([...urlParams.keys()].length > 0) {
        window.location.search = urlParams;
      } else {
        window.location = window.location.href.split("?")[0];
      }
    });
  });

  $(document).on("onFilterOrderChanged", (e, args) => {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set("orderby", args.value);
    window.location.search = urlParams;
  });
});

function handleFilter(filter) {
  let isHasCganges = false;
  let selectedItems = [];
  let appliedItems = [];
  let suggestionItemsFeatured = [];

  const apply = $(filter).find('*[data-action="filter-apply"]')[0];
  const cancel = $(filter).find('*[data-action="filter-cancel"]')[0];
  const clear = $(filter).find('*[data-action="filter-clear"]')[0];
  const suggestions = $(filter).find('*[data-ui="suggestions"]')[0];

  const suggestionItems = $(suggestions).children(".suggestions-item");

  $(suggestionItems).each((index, suggestionItem) => {
    suggestionItemsFeatured.push(suggestionItem);
  });

  function handleSuggestionItems() {
    const suggestionItems = $(suggestions).children("*[data-value]");

    $(suggestionItems).each((index, suggestionItem) => {
      $(suggestionItem).on("click", (suggestionItem) => {
        const suggestionItemValue = $(suggestionItem.target).attr("data-value");
        const foundIndex = selectedItems.findIndex(
          (e) => e === suggestionItemValue
        );
        foundIndex === -1
          ? selectedItems.push(suggestionItemValue)
          : selectedItems.splice(foundIndex, 1);

        isHasCganges = true;
        prepareButtons();
      });
    });
  }

  prepareItems();
  prepareButtons();
  handleSuggestionItems();

  $(clear).on("click", (e) => {
    isHasCganges = true;
    selectedItems = [];
    rebuildList();
    prepareButtons();
  });

  $(cancel).on("click", (e) => {
    selectedItems = [];
    $(filter).find("input").val("");
    $(filter).find('*[data-action="clear"]').css({ opacity: 0 });
    closeFilter();
    prepareSuggestionItemsFromFeatured();
    rebuildList();
  });

  $(apply).on("click", (e) => {
    $(document).trigger("onFilterApplied");
  });

  function closeFilter() {
    $(filter).removeClass("dropdown-open");
  }

  function rebuildList() {
    const suggestionItems = $(suggestions).children("*[data-value]");

    $(suggestionItems).each((index, suggestionItem) => {
      const suggestionItemValue = $(suggestionItem).data("value").toString();
      const foundIndex = selectedItems.findIndex(
        (e) => e === suggestionItemValue
      );

      foundIndex === -1
        ? $(suggestionItem).removeClass("active")
        : $(suggestionItem).addClass("active");
    });
  }

  function prepareButtons() {
    $(apply).addClass("disabled").attr("disabled", "disabled");

    if (
      (isHasCganges && !!appliedItems.length) ||
      (isHasCganges && !!selectedItems.length && !appliedItems.length)
    ) {
      $(apply).removeClass("disabled").removeAttr("disabled", "disabled");
    }
  }

  function prepareItems() {
    const filterType = $(filter).data("page-filter");
    const queryParams = new URLSearchParams(location.search);
    const values = queryParams.get(filterType);
    const valuesArr = values ? values.split(",") : [];
    const suggestionItems = $(suggestions).children("*[data-value]");
    const GTM_ITEMS = [];
    const GTM_EVENTS = {
      destination: "applyVenuesDestinationsFilter",
      type: "applyVenuesTypeFilter",
    };

    $(suggestionItems).each((index, suggestionItem) => {
      const suggestionItemValue = $(suggestionItem).data("value").toString();
      if (valuesArr.includes(suggestionItemValue)) {
        selectedItems.push(suggestionItemValue);
        appliedItems.push(suggestionItemValue);
        GTM_ITEMS.push(suggestionItem.innerHTML.trim());
      }
    });

    if (GTM_EVENTS[filterType] && GTM_ITEMS.length > 0) {
      dataLayer.push({
        event: GTM_EVENTS[filterType],
        event_data: GTM_ITEMS.join(","),
      });
    }

    if (appliedItems.length) {
      $("body").addClass("filter-applied");

      $(filter)
        .addClass("active")
        .children(".dropdown-select-label")
        .append(`<i>${appliedItems.length}</i>`);
    }

    rebuildList();
  }

  function prepareSuggestionItemsFromFeatured() {
    $(suggestions).empty().append(suggestionItemsFeatured);
    prepareButtons();
    handleSuggestionItems();
    setTimeout(() => {
      forms.suggestions.init();
    }, 30);
  }

  $(document).on("onDropdownOpened", function (e, args) {
    selectedItems = !!appliedItems.length ? $.merge([], appliedItems) : [];

    setTimeout(() => {
      $(args.element).find("input").trigger("focus");
    }, 30);
    rebuildList();
    prepareButtons();
  });

  const input = $(filter).find($('*[data-ui="input"]'));

  $(input).on("input", (e) => {
    if (e.target.value.length === 0) {
      prepareSuggestionItemsFromFeatured();
      rebuildList();
    } else if (e.target.value.length > 2) {
      $.ajax({
        url: `/ajax/cities/search?query=${e.target.value.toLowerCase()}`,
        success: function (data) {
          handleAjaxResult(e.target.value, data);
        },
      });
    }
  });

  $(input)
    .children('*[data-action="clear"]')
    .on("click", () => {
      prepareSuggestionItemsFromFeatured();
      rebuildList();
    });

  function handleAjaxResult(query, data) {
    if (!Array.isArray(data)) return false;

    $(suggestions).empty();
    if (data.length === 0) {
      $(suggestions).append(
        `<li class="suggestions-item suggestions-item__no-result">No results for <strong>"${query}"</strong></li>`
      );
      return false;
    }

    data.forEach((city) => {
      const suggestionItem = $(
        `<li class="suggestions-item" data-value="${city.id}">${formatSuggestionsString(city.name, query)}</li>`
      );
      $(suggestions).append(suggestionItem);
    });

    rebuildList();
    prepareButtons();
    handleSuggestionItems();
    forms.suggestions.init();
  }
}

function formatSuggestionsString(str, needle) {
  const startIndex = str
    .toLocaleLowerCase()
    .indexOf(needle.toLocaleLowerCase());
  const searchValue = str.substring(startIndex, startIndex + needle.length);
  const replaceValue = `<strong>${searchValue}</strong>`;
  return str.replace(searchValue, replaceValue);
}
